export const faqs = [
  {
    question: "What if I'm not ready to continue after my trial?",
    answer: "No problem at all. If you decide not to continue after your 7-day ThriveMax trial, your account automatically shifts to limited access mode. You keep your existing data, basic dashboard access, your baseline room scan, and MyDailyCheckIn. Upgrade anytime when you're ready."
  },
  {
    question: "How does the 7-day trial work for older adults?",
    answer: "Older adults start with full ThriveMax access for 7 days — no credit card required. After the trial, choose to continue with ThriveMax or automatically move to limited access mode where your data is always preserved."
  },
  {
    question: "How does the free trial work for family members?",
    answer: "Family members can explore the platform for free with no time limit! You'll have access to preview features and learn about SeniorThrive. Payment only begins when your older adult loved one activates their account and you choose a family plan."
  },
  {
    question: "What happens after my trial ends?",
    answer: "If you don't upgrade, you'll automatically move to limited access mode (free forever) with basic features and read-only access to your trial data."
  },
  {
    question: "Can I upgrade or downgrade anytime?",
    answer: "Yes! You can change plans anytime. Upgrades take effect immediately, and downgrades take effect at your next billing cycle."
  },
  {
    question: "Is ThriveFamily free to explore?",
    answer: "Yes, it's free to explore. You can create your Family Dashboard and invite others anytime. Billing only begins once your loved one activates their Thrive account."
  },
  {
    question: "How will I know when billing starts?",
    answer: "You'll get a notification and confirmation email before activation billing begins — no hidden charges."
  },
  {
    question: "Can multiple family members join before activation?",
    answer: "Absolutely. Up to 5 family members can explore SeniorThrive together, all free until activation."
  },
  {
    question: "What is ThriveFamily+?",
    answer: "ThriveFamily+ is an add-on for families managing more complex caregiving situations. It provides expanded care coordination and communication tools for family members who need clearer visibility, shared responsibility, and tighter alignment. Available as an add-on to ThriveFamily."
  },
  {
    question: "What is the ThriveCare Add-On?",
    answer: "ThriveCare allows families to invite professional caregivers into their ThriveCircle. Professional caregivers get access to care documentation, scheduling, and communication tools — all within the family's existing care coordination system. Available when invited by a family using ThriveFamily or ThriveFamily+."
  }
];
